<template>
    <a-table
        :columns="columns"
        :data-source="data"
    >
        <template slot="operation" slot-scope="text,record">
            <span class="csP mr20px" style="color:#7ebae5">同意</span>
            <span class="csP" style="color:#7ebae5" @click="deleteItem(record)">删除</span>
        </template>
    </a-table>
</template>
<script>
const columns = [
  { title: '课程包名称', dataIndex: 'name', align:'center' }, 
  { title: '处理事项', dataIndex: 'age', align:'center' }, 
  { title: '状态', dataIndex: 'wechart', align:'center' }, 
  { title: '时间', dataIndex: 'content2', align:'center' }, 
  { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align:'center' },
];
export default {
    name: 'dealRecord',
    data(){
        return{
            columns,
            data: [],
            currentItem: null,
            visible: false
        }
    },
    methods:{
        deleteItem(id){
            let _this = this
            this.$confirm({
                title: '是否确定删除该条信息?',
                centered: true,
                onOk() {
                },
            });
        }
    }
}
</script>